// Mini-historial de un plan/política (`.hist-block` del mock): fecha · chip de evento · detalle.
import { EventTag } from './ui';

export interface HistoryRow {
    date: string;
    kind: 'plan' | 'store_policy';
    change: string;
    reason: string;
    /** Quién lo hizo, tal como lo manda la bitácora (`system` o un `cognitoSub`). */
    author?: string;
}

export function HistoryList({ rows }: { rows: HistoryRow[] }) {
    return (
        <div className="overflow-hidden rounded-md border border-border bg-card">
            {rows.length === 0 ? (
                <div className="px-3 py-3 text-center text-[10.5px] italic text-muted-foreground">
                    Sin eventos registrados
                </div>
            ) : (
                rows.map((row, i) => {
                    // Sin motivo ni autor el separador quedaba colgando: «Plan creado ·».
                    const detail = [row.author, row.reason].filter(Boolean).join(' · ');
                    return (
                        <div
                            key={`${row.date}-${String(i)}`}
                            className="grid grid-cols-[80px_auto_1fr] items-center gap-2 border-b border-border/40 px-2.5 py-[5px] text-[10.5px] last:border-b-0"
                        >
                            <span className="tabular-nums text-muted-foreground">{row.date}</span>
                            <EventTag kind={row.kind} />
                            <span>
                                {row.change}
                                {detail === '' ? null : (
                                    <span className="text-muted-foreground"> · {detail}</span>
                                )}
                            </span>
                        </div>
                    );
                })
            )}
        </div>
    );
}
